import axios from 'config/axios';

export const fetchOverAllScoreByAssessment =  async (params) => {
  try {
      let  response  = await axios.get(`${process.env.REACT_APP_CAP_ENDPOINT_URL}/assessment/overallScore`,
      {
      params: params,
      });
      return response;   
    
 
  } catch (error) {
    return error;
  }
};

export const fetchOverAllScoreByCompany =  async (params) => {
  try {
      let  response  = await axios.get(`${process.env.REACT_APP_CAP_ENDPOINT_URL}/standards/getAggregatedOverallScoreByCompany`,
      {
      params: params,
      });
      return response;   
  } catch (error) {
    return error;
  }
};

export const fetchOverallMainControlScores =  async (params) => {
  try {
   
      let  response  = await axios.get(`${process.env.REACT_APP_CAP_ENDPOINT_URL}/assessment/overallMainControlScores`,
      {
      params: params,
      });
      
      return response;   
    
 
  } catch (error) {
    return error;
  }
};

export const fetchOverAllScorebydate =  async ({  idToken,params }) => {
  try {
   
      let  response  = await axios.get(`${process.env.REACT_APP_CAP_ENDPOINT_URL}/assessment/overallScorebydate`,
      {headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${idToken}`,
      },
      params: params,
      });
      
      return response;   
    
 
  } catch (error) {
  }
};
//Code change for 403 error during session data testing
export const putAssessmentStatus =  async (body) => {
  try {   
      let  response  = await axios.put(`${process.env.REACT_APP_CAP_ENDPOINT_URL}/assessment/status`,body,
      {
        'Content-Type': 'application/json',
      });
      if(response?.status === 200 || response?.status === 201)
      return response;   
    
 
  } catch (error) {
    throw error; //Code change for 403 error during session data testing
  }
};

// US-CAP-301: Extend an assessment's due date. Requires a mandatory reason.
// Resumes an "On Hold" assessment back to its prior in-progress status.
export const extendAssessmentDueDate = async (body) => {
  try {
    let response = await axios.patch(`${process.env.REACT_APP_CAP_ENDPOINT_URL}/assessment/extendDueDate`, body,
    {
      'Content-Type': 'application/json',
    });
    return response;
  } catch (error) {
    throw error;
  }
};

export const updateMitigations =  async (formData) => {
  try {
      let  response  = await axios.put(`${process.env.REACT_APP_CAP_ENDPOINT_URL}/assessment/updatemitigations`,formData,
      {
        'Content-Type': 'application/json',
      });
      
      return response;   
  } catch (error) {
  }
};

export const uploadEvidence =  async ({submissionid, formData }) => {
  try {
    let  response  = await axios.post(`${process.env.REACT_APP_CAP_ENDPOINT_URL}/assessment/uploadevidence/${submissionid}`,formData,
    {
      'Content-Type': 'application/json',
    });  
    return response;   
  } catch (error) {
    return error;
  }
};

// US-CAP-302: Upload one or more evidence files while filling in the
// self-assessment. formData should contain `assessment_id`, `subcontrol`,
// and one or more `files` entries. Server enforces a 2 MB-per-file limit.
export const uploadSelfAssessmentEvidence = async (formData) => {
  try {
    let response = await axios.post(
      `${process.env.REACT_APP_CAP_ENDPOINT_URL}/assessment/uploadSelfAssessmentEvidence`,
      formData,
      { 'Content-Type': 'multipart/form-data' },
    );
    return response;
  } catch (error) {
    throw error;
  }
};

export const updateMultipleMitigationResponses =  async ({updatedItemList }) => {
  try {
    let  response  = await axios.put(`${process.env.REACT_APP_CAP_ENDPOINT_URL}/assessment/updatemultiplemitigationresponses`,updatedItemList,
    {
      'Content-Type': 'application/json',
    });  
    return response;   
  } catch (error) {
    return error;
  }
};

export const updateRejectedAssessmentComments =  async (data) => {
  try {   
      let  response  = await axios.put(`${process.env.REACT_APP_CAP_ENDPOINT_URL}/assessment/updateRejectedAssessmentComments`,data,
      {
        'Content-Type': 'application/json',
      });
      
      return response;   
    
 
  } catch (error) {
  }
};

export const updateRejectedMitigationComments =  async (body ) => {
  try {
    let  response  = await axios.put(`${process.env.REACT_APP_CAP_ENDPOINT_URL}/assessment/updateRejectedComments`,body,
    {
      'Content-Type': 'application/json',
    });  
    return response;   
  } catch (error) {
    return error;
  }
};

export const fetchMitreMappings =  async (params) => {
  try {
      let mitreresponse = await axios.get(`${process.env.REACT_APP_CAP_ENDPOINT_URL}/assessment/mitremappings/`+params.companyid+`?standard=`+params.standardid+`&severity=all`,{});
      return mitreresponse;   
  } catch (error) {
  }
};